// import React from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';

function Loading() {
  return null;
  // <div className="loadable-loading-wrapping">
  //   <OriLoading isLoading={true} />
  // </div>
}

function LoadableWrapper(importFunc, LoadingComp = Loading) {
  return Loadable({
    loader: importFunc,
    loading: LoadingComp,
  });
}

LoadableWrapper.propTypes = {
  importFunc: PropTypes.func,
  loading: PropTypes.element,
};

export default LoadableWrapper;
